import { ReactComponent as ChevronRightSvg } from '../../assets/icons/chevron-right.svg';

export const ChevronRightIcon: SvgIcon = (props) => {
    return <ChevronRightSvg {...props} />;
};
